export default "__VITE_ASSET__KCRcSYma__"